import * as MovieApi from "movieapi";
// based on https://hptechblogs.com/using-json-web-token-react/

export interface ILoginMessage {
  ok: boolean;
  msg: string;
}

export default class AuthService {
  // Initializing important variables
  constructor() {
    this.login = this.login.bind(this);
    this.setToken = this.setToken.bind(this);
    this.getToken = this.getToken.bind(this);
    this.logout = this.logout.bind(this);
    this.isLoggedIn = this.isLoggedIn.bind(this);
    this.getConfiguration = this.getConfiguration.bind(this);
  }

  public async login(
    username: string,
    password: string
  ): Promise<ILoginMessage> {
    // tslint:disable-next-line:no-console
    console.log(process.env.REACT_APP_BASE_URL);
    const api = new MovieApi.LoginApi(
      undefined,
      process.env.REACT_APP_BASE_URL
    );
    return await api
      .loginForTheUser({
        password,
        username
      })
      .then(res => {
        if (res.access_token === undefined) {
          throw Error("null access token");
        } else {
          this.setToken(res.access_token);
          return { ok: true, msg: "" };
        }
      })
      .catch(reason => {
        return Promise.resolve(
          reason.json().then((res: any) => {
            return { ok: false, msg: res.message };
          })
        );
      });
  }

  public isLoggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken(); // GEtting token from localstorage
    return token !== null;
  }

  public logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem("id_token");
  }

  public getConfiguration(): MovieApi.Configuration {
    return new MovieApi.Configuration({
      apiKey: "Bearer " + this.getToken()
    });
  }

  private setToken(accessToken: string) {
    // Saves user token to localStorage
    localStorage.setItem("id_token", accessToken);
  }

  private getToken(): string | null {
    // Retrieves the user token from localStorage
    return localStorage.getItem("id_token");
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AuthService.tsx